import * as React from 'react';

const ArrowTopLeft24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M6.057 6.463A.8.8 0 0 0 6 6.75v10.5a.75.75 0 0 0 1.5 0V8.56l9 8.94a.75.75 0 0 0 1.06-1.06l-9-8.94h8.69a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0-.693.463"
  }
));
ArrowTopLeft24.Size = 24;
ArrowTopLeft24.Title = "ArrowTopLeft";

export { ArrowTopLeft24 as default };
